import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { MdQrCodeScanner } from "react-icons/md";
import "./SearchBar.css";

const SearchBar = () => {

  const ads = [
    "⚽ Pick and win big on Outcomes",
    "⚽ Predict the winner and earn rewards",
    "⚽ Daily football matches available",
    "🔥 SOL frequently traded",
    "🔥 PI commonly searched",
    "🔥 BTC trending now",
    "🔥 ETH most searched",
    "🔥 XRP hot today"
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % ads.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="search-wrapper">

      <div className="search-container">

        <FaSearch className="search-icon" />

        <input
          type="text"
          value={ads[index]}
          readOnly
        />

      </div>

      <div className="scan-btn">
        <MdQrCodeScanner className="scan-icon" />
      </div>

    </div>
  );
};

export default SearchBar;